import {css} from "@emotion/react";

//Mikołaj: I think typing degrees as string is not specific enough
export type Rotation = "0" | "45" | "90" | "180" | "270";

export const rotate = (degrees: Rotation = "180") => css`
    rotate: ${degrees}deg;
`;
